import { render, staticRenderFns } from "./UserChangePassword.vue?vue&type=template&id=61d69ae4&"
import script from "./user-change-password.js?vue&type=script&lang=js&"
export * from "./user-change-password.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports